<script>
import { mapGetters } from 'vuex';
import WhatsappTemplates from 'dashboard/components/widgets/conversation/WhatsappTemplates/Modal.vue';

export default {
  components: { WhatsappTemplates },
  props: {
    modelValue: {
      type: Object,
      default: () => null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedInboxId: null,
      whatsappTemplateMessage: null,
      showWhatsAppTemplatesModal: false,
    };
  },
  computed: {
    ...mapGetters({
      inboxes: 'inboxes/getInboxes',
    }),
    whatsappInboxes() {
      return this.inboxes.filter(
        inbox => inbox.channel_type === 'Channel::Whatsapp'
      );
    },
  },
  mounted() {
    this.selectedInboxId = this.modelValue[0]?.selected_inbox_id;
    this.whatsappTemplateMessage =
      this.modelValue[0]?.whatsapp_template_message;
    this.updateValue();
  },
  methods: {
    updateSelectedInboxId(event) {
      const newSelectedInboxId = Number(event.target.value);
      this.selectedInboxId = newSelectedInboxId;
      if (this.whatsappTemplateMessage) this.whatsappTemplateMessage = null;
      this.updateValue();
    },
    hideWhatsappTemplatesModal() {
      this.showWhatsAppTemplatesModal = false;
    },
    async onSendWhatsappReply(messagePayload) {
      try {
        this.whatsappTemplateMessage = messagePayload;
        this.updateValue();
        this.hideWhatsappTemplatesModal();
      } catch (error) {
        this.hideWhatsappTemplatesModal();
      }
    },
    openWhatsappTemplateModal() {
      this.showWhatsAppTemplatesModal = true;
    },
    updateValue() {
      this.$emit('update:modelValue', {
        selected_inbox_id: this.selectedInboxId,
        whatsapp_template_message: this.whatsappTemplateMessage,
      });
    },
  },
};
</script>

<template>
  <div>
    <select
      v-model="selectedInboxId"
      class="max-w-full mb-0 mt-1 mr-1"
      :allow-empty="false"
      @input="updateSelectedInboxId"
    >
      <option
        v-for="inbox in whatsappInboxes"
        :key="inbox.id"
        :value="inbox.id"
      >
        {{ inbox.name }}
      </option>
    </select>
    <div class="flex flex-col mt-[--space-small]">
      <a
        class="font-[--font-weight-medium] !p-[--space-zero] w-max"
        @click="openWhatsappTemplateModal"
      >
        Selecionar modelo de mensagem
      </a>
      <hr
        v-if="whatsappTemplateMessage"
        class="opacity-10 my-[--space-smaller] mx-[--space-zero]"
      />
      <p
        v-if="whatsappTemplateMessage"
        class="opacity-80 my-[--space-smaller] mx-[1%] max-w-[98%]"
      >
        {{ whatsappTemplateMessage.message }}
      </p>
    </div>
    <WhatsappTemplates
      disable-file-templates
      :inbox-id="selectedInboxId"
      :show="showWhatsAppTemplatesModal"
      @close="hideWhatsappTemplatesModal"
      @on-send="onSendWhatsappReply"
      @cancel="hideWhatsappTemplatesModal"
    />
  </div>
</template>
